import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class AddressService {
  urlGateway = environment.api_gateway;

  constructor(
    private http: HttpClient
  ) { }

  getAddressByCep(params = {}): Observable<any> {
    return this.http.post<any>(`${this.urlGateway}/api/users/address/get/bycep/v1/`, params);
  }
  getGeolocation(params = {}): Observable<any> {
    return this.http.post<any>(`${this.urlGateway}/api/users/address/geolocation/v1/`, params);
  }
}
